import { z } from 'zod';

export const couponResponseSchema = z
  .object({
    coupon_code: z.string(),
    percent_discount: z.number(),
    expires_at: z.string(),
  })
  .transform((data) => ({
    couponCode: data.coupon_code,
    percentDiscount: data.percent_discount,
    expiresAt: data.expires_at,
  }));

export const couponSchema = z.object({
  couponCode: z.string(),
  percentDiscount: z.union([z.number(), z.string()]).transform((value) => Number(value)),
  expiresAt: z.string(),
});

export type Coupon = z.infer<typeof couponSchema>;
export type CouponResponse = z.infer<typeof couponResponseSchema>;
export type CouponResponseResponse = z.input<typeof couponResponseSchema>;
